export const CALENDAR_SELECTIONS_SESSION_STORAGE_KEY = 'calendarSelections';

/**
 * Single-use signal meaning "the user just resolved the services-preferences
 * modal and we are about to (re)load / navigate into the calendar".
 *
 * It is armed together with every `storeCalendarSelections` write and consumed
 * once by the calendar on init (see `consumePreferencesResolved`), so the
 * calendar suppresses the auto-open only for that immediate load. A later
 * refresh, fresh visit, or cart return finds no signal and re-opens the modal.
 *
 * Coupling it to the store - rather than asking each caller to set it - is
 * deliberate: every surface that hands a resolved basket to the calendar (the
 * calendar's own modal flow, the service page, the service list, the book
 * button, ...) goes through `storeCalendarSelections`, so none of them can
 * forget to arm the suppressor. Keying off the lingering `calendarSelections`
 * value instead is not possible: the same value is present both when the modal
 * was just resolved elsewhere (suppress) and when the user refreshes the
 * calendar after a previous resolution (re-open) - see SCHED-47215 /
 * SCHED-47264.
 */
export const PREFERENCES_RESOLVED_SESSION_STORAGE_KEY = 'calendarPreferencesResolved';
export const storeCalendarSelections = _ref => {
  let {
    calendarSelections,
    session
  } = _ref;
  session.setItem(CALENDAR_SELECTIONS_SESSION_STORAGE_KEY, JSON.stringify(calendarSelections));
  session.setItem(PREFERENCES_RESOLVED_SESSION_STORAGE_KEY, 'true');
};
export const cleanCalendarSelections = _ref2 => {
  let {
    session
  } = _ref2;
  session.removeItem(CALENDAR_SELECTIONS_SESSION_STORAGE_KEY);
  session.removeItem(PREFERENCES_RESOLVED_SESSION_STORAGE_KEY);
};

/**
 * Reads and clears the one-shot preferences-resolved signal. Returns `true`
 * when it was set - i.e. the modal was just resolved and the calendar should
 * not auto-open it again for this load.
 */
export const consumePreferencesResolved = _ref3 => {
  let {
    session
  } = _ref3;
  const wasResolved = !!session.getItem(PREFERENCES_RESOLVED_SESSION_STORAGE_KEY);
  if (wasResolved) {
    session.removeItem(PREFERENCES_RESOLVED_SESSION_STORAGE_KEY);
  }
  return wasResolved;
};
//# sourceMappingURL=storeCalendarSelections.js.map